import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import Home from './pages/Home';
import Cadastro from './pages/Cadastro';


// LABORATÓRIO (ORDEM DE SERVIÇO)
import ListaOS from './pages/OrdensServico';

// ESTOQUE
import Estoque from './pages/Estoque';
import Produtos from './pages/Produtos';

// NOVO: MENSAGENS WHATSAPP
import Mensagens from './pages/Mensagens'; // Importando a nova página
import Empresas from './pages/Empresas'; // Importando a nova página

// ROTAS PROTEGIDAS
import PrivateRoute from './routes/PrivateRoute';
import AdminRoute from './routes/AdminRoute';
import MobileCamera from './pages/components/MobileCamera';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* LOGIN */}
        <Route path="/login" element={<Login />} />
        <Route path="/camera/:sessionId" element={<MobileCamera />} />

        {/* HOME */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />

        {/* CADASTRO DE USUÁRIO (ADMIN) */}
        <Route
          path="/cadastro"
          element={
            <AdminRoute>
              <Cadastro />
            </AdminRoute>
          }
        />
        <Route
          path="/empresas"
          element={
            <AdminRoute>
              <Empresas />
            </AdminRoute>
          }
        />

       

        {/* ===== LABORATÓRIO ===== */}
        <Route
          path="/ordens-servico"
          element={
            <PrivateRoute>
              <ListaOS />
            </PrivateRoute>
          }
        />

        {/* ===== ESTOQUE DE ARMAÇÕES ===== */}
        <Route
          path="/estoque"
          element={
            <PrivateRoute>
              <Estoque />
            </PrivateRoute>
          }
        />

        {/* ===== NOVO: MENSAGENS WHATSAPP ===== */}
        <Route
          path="/mensagens"
          element={
            <PrivateRoute>
              <Mensagens />
            </PrivateRoute>
          }
        />
 <Route
          path="/produtos"
          element={
            <PrivateRoute>
              <Produtos />
            </PrivateRoute>
          }
        />
        {/* FALLBACK */}
        <Route path="*" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;